import { createSlice, isAction } from "@reduxjs/toolkit";
import {
  fetchModelById,
  fetchModels,
  updateModel,
  updateStatusInModel,
  fetchModelByDropDown,
  fetchModelByMakeDropDown
} from "./thunk";

interface ModelState {
  modelList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedModel: any;
}

const initialState: ModelState = {
  modelList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedModel: null,
};

const modelSlice = createSlice({
  name: "model",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchModelByDropDown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchModelByDropDown.fulfilled, (state, action) => {
        state.loading = false;
        state.modelList = action.payload.data || [];
        state.rowCount = action.payload.rowCount || 0;
      })
      .addCase(fetchModelByDropDown.rejected, (state, action) => {
        console.log('fetchModelByDropDown rejected:', action.error);
        state.loading = false;
        state.error = action.error.message || "Failed to fetch models";
      })
      .addCase(fetchModelByMakeDropDown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchModelByMakeDropDown.fulfilled, (state, action) => {
        state.loading = false;
        state.modelList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchModelByMakeDropDown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch models by make";
      })
      .addCase(fetchModels.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchModels.fulfilled, (state, action) => {
        state.loading = false;
        state.modelList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchModels.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch packages";
      })
      .addCase(fetchModelById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchModelById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedModel = action.payload;
      })
      .addCase(fetchModelById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateModel.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.modelList = state.modelList.map((dist) =>
          dist.id === action.payload.id ? action.payload : dist
        );
      })
      .addCase(updateModel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update packages";
      })
      .addCase(updateStatusInModel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch packages";
      });
  },
});

export default modelSlice.reducer;
